<template lang="pug">
.supportFormComponent
  .formWrapper(v-if="!isFormSent")
    .title С какой проблемой вы хотите обратиться?
    .form
      .row
        .col
          .text Введите свою почту
        .col
          ui-input(
            v-model.trim="form.email"
            :v$="v$.email"
            :errors="errors.email"
            @blur="v$.email.$touch"
          )
      .row
        .col
          .text Выберите тему
        .col
          ui-dropdown-select.dropdown(
            is-responsive
            v-model="form.theme"
            :options="themes"
            :v$="v$.theme"
            :errors="errors.theme"
            @update:modelValue="v$.theme.$touch"
          )
      .row
        .col
          .text Введите сообщение
        .col
          ui-textarea(
            v-model.trim="form.message"
            :v$="v$.message"
            :errors="errors.message"
            @blur="v$.message.$touch"
          )
      .row
        .col
          .text Прикрепить файл
          .hint._files (макс. {{ filesMaxLength }} файлов, {{ fileMaxSize }} мб.)
        .col
          ui-file(
            color="blue-outline"
            @update="data => updateFiles(data)"
            :v$="v$.files"
            :errors="errors.files"
            :max-size="fileMaxSize"
          )
    .submitWrapper
      ui-button.button(
        @click="onSubmit"
        :is-loading="sendRequestIsLoading"
      ) Отправить обращение
  .success(v-else)
    .title Спасибо за ваше обращение!
    .text Мы уже начали работу над ним
    .buttonWrapper
      ui-button.button(@click="$emit('close')") Вернуться на платформу
</template>

<script>
import UiButton from '@/components/_ui/UiButton'
import UiInput from '@/components/_ui/UiInput'
import UiTextarea from '@/components/_ui/UiTextarea'
import SupportFormController from '@/controllers/SupportFormController'

export default {
  components: {
    UiTextarea,
    UiInput,
    UiButton
  },
  emits: ['close'],
  setup () {
    const {
      requestThemes,
      isFormSent,
      fileMaxSize,
      filesMaxLength,
      themes,
      form,
      v$,
      errors,
      updateFiles,
      onSubmit,
      sendRequestIsLoading
    } = SupportFormController()

    requestThemes()

    return {
      isFormSent,
      fileMaxSize,
      filesMaxLength,
      themes,
      form,
      v$,
      errors,
      updateFiles,
      onSubmit,
      sendRequestIsLoading
    }
  }
}
</script>

<style lang="sass" scoped>
.supportFormComponent
  .title
    @include font('h2')
    @media (max-width: $XXSWidth)
      @include font('m-h2')

  .formWrapper
    width: 566px
    @media (max-width: $padWidth)
      width: 100%
    .title
      margin-bottom: 11*$u
      padding-right: 10*$u
    .form
      display: flex
      width: 100%
      flex-direction: column
      margin-top: -4*$u
    .row
      margin-top: 4*$u
      display: flex
      margin-left: -4*$u
      @media (max-width: $padWidth)
        flex-direction: column
        margin: 0
    .col
      margin-left: 4*$u
      &:first-child
        flex: 0 0 160px
        text-align: right
        @media (max-width: $padWidth)
          text-align: left
          flex: initial
          margin: 4*$u 0 0 0
      &:last-child
        flex: 1 0 1px
        max-width: 330px
        @media (max-width: $padWidth)
          flex: initial
          margin: $u 0 0 0
          max-width: initial

      .text
        @include font('t16-medium')

      .hint
        @include font('t14-regular')
        color: $cDarkGrey
        &._files
          @media (max-width: $padWidth)
            margin-bottom: $u

    .submitWrapper
      margin-top: 10*$u
      margin-bottom: 3*$u
      .button
        margin: 0 auto
        @media (max-width: $padWidth)
          width: 100%

  .success
    padding: 0 10*$u
    @media (max-width: $XXSWidth)
      padding: 0 5*$u
    .title
      margin-bottom: 4*$u
      text-align: center
    .text
      @include font('t18-regular')
      margin-bottom: 6*$u
      text-align: center
    .buttonWrapper
      .button
        margin: 0 auto
</style>
